import { render, staticRenderFns } from "./sideBanner.vue?vue&type=template&id=1e66c8be&scoped=true"
import script from "./sideBanner.vue?vue&type=script&lang=js"
export * from "./sideBanner.vue?vue&type=script&lang=js"
import style0 from "./sideBanner.vue?vue&type=style&index=0&id=1e66c8be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e66c8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e66c8be')) {
      api.createRecord('1e66c8be', component.options)
    } else {
      api.reload('1e66c8be', component.options)
    }
    module.hot.accept("./sideBanner.vue?vue&type=template&id=1e66c8be&scoped=true", function () {
      api.rerender('1e66c8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/sideBanner.vue"
export default component.exports